import withModalController from './controller';

export * from './Modal/styles';

export default withModalController;
